module.exports = __webpack_public_path__ + "img/adaptations11.2f980084.png";